import axios from 'axios'
import { getProfilesFromStatusAPI } from '../api'

export const getProfilesFromStatus = async (bookingId, status) => {
    try {
        return await axios.get(getProfilesFromStatusAPI(bookingId, status))
    } catch (error) {
        return { success: false, error: error.message }
    }
}
